const $ = require('jquery');

if (/kits\-e\-programas/igm.test(location.pathname)) {
	$el = $('.view-categorias');
	if ($el.length != 0) {		
		const CategoriasKitsView = require('./views/kits/categorias');
		
		new CategoriasKitsView({
			el: $el
		});
	}
}

if (/(produtos|home|busca|cardapio\-completo)/igm.test(location.pathname)||/equilibrio-2017[\/]?$/igm.test(location.pathname)||''==location.pathname||'/'==location.pathname) {
	$el = $('.view-categorias');
	if ($el.length != 0) {
		const CategoriasKitsView = require('./views/cardapio/categorias');
		
		new CategoriasKitsView({
			el: $el
		});
	}
}

if (/mercadinho\-saudavel/igm.test(location.pathname)) {
	$el = $('.view-categorias');
	if ($el.length != 0) {
		const CategoriasKitsView = require('./views/mercadinho/categorias');
		
		new CategoriasKitsView({
			el: $el
		});
	}
}


$el = $('.view-kits');
if ($el.length != 0) {
	const KitsView = require('./views/kits/index');
	new KitsView({
		el: $el
	});
}

$el = $('.view-kit');
if ($el.length != 0) {
	const KitInternaView = require('./views/kits/interna/index');
	var kit = $el.data('kit');

	kit.editavel = kit.editavel|0;
	kit.ativo = kit.ativo|0;
	kit.deleted = kit.deleted|0;
	kit.destaque = kit.destaque|0;
	kit.id = kit.id|0;
	kit.promocao = kit.promocao|0;
	kit.recomendado_semana = kit.recomendado_semana|0;
	
	var produtos = $el.data('produtos');
	new KitInternaView({
		el: $el,
		preco_de: $('.preco-de'),
		preco_por: $('.preco-por'),
		calorias_dia: $('.kit-calorias-dia'),
		quantidade: $('[name=quantidade]'),
		kit: kit,
		produtos: produtos
	});
}


$el = $('.view-vitrine-busca');
if ($el.length != 0) {
	const BuscaView = require('./views/busca/index');

	new BuscaView({
		el: $el,
		model: new Backbone.Model($el.data()),
		collection: new Backbone.Collection()
	});
}	



require('../src/app');


//////////////////
// WEBPACK FOOTER
// ./main.js
// module id = 5
// module chunks = 0